import heroImage from "../assets/home_splash_bookkeeping.png";

export default function Home() {
  return (
    <div className="page home">

      {/* ===== ORIGINAL SIMPLE WELCOME ===== */}
      <section className="card" style={{ marginTop: "1.5rem" }}>
        <h2>Welcome to, One Outsource Project Support Services, LLC</h2>
        <p>
          Your partner in helping you or your organization achieve it's project oriented goals.
        </p>
      </section>

      {/* ===== NEW HERO / INTAKE CTA ===== */}
      <section className="hero">
        <div className="hero-text">
          <h1>We offer Project Support for businesses, simplified.</h1>
          <p>
            Submit your project intake and get matched with vetted professionals
            for bookkeeping, financial reporting, budgeting, and administrative
            support.
          </p>

          <div className="hero-actions">
            <a href="/signup" className="btn primary">
              Create an Account
            </a>
            {/* <a href="/intake/start" className="btn secondary">
              Start Project Intake
            </a> */}
          </div>
        </div>

        <div className="hero-image">
          <img
            src={heroImage}
            alt="Bookkeeping and financial services illustration"
          />
        </div>
      </section>

      {/* ===== ORIGINAL CONTENT (ENHANCED) ===== */}
      <section className="features">
        <div className="card">
          <h3>What We Do</h3>
          <p>
            We assist individuals and businesses achieve their project drivern goals by connecting them with experienced professionals.
          </p>
        </div>

        <div className="card">
          <h3>How It Works</h3>
          <p>
            Complete a short intake, review your options, and start working with
            a trusted team member.
          </p>
        </div>

        <div className="card">
          <h3>Why 1OPSS</h3>
          <p>
            1OPSS are contracted services with flexible working models, to provide on-the-spot support for your immediate project needs.
          </p>
        </div>
      </section>

      {/* ===== FINAL CTA ===== */}
      <section className="card" style={{ marginTop: "2rem", textAlign: "center" }}>
        <h3>Ready to Get Started?</h3>
        <p>
          Submit your project intake and let us handle the rest.
        </p>
        <a href="/intake/start" className="btn primary"
          style={{"marginTop":"10px"}}
        >
          
          Begin Intake
        </a>
      </section>

    </div>
  );
}
